
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[...name]",
      function () {
        return require("private-next-pages/articles/[...name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[...name]"])
      });
    }
  